import { endpoints } from "../../services/endpoint.ts/endpoint";
import { request } from "../../services/base.service";

/**
 * 라이선스 현황을 조회합니다.
 *
 * store/api/action.js 의 getData 를 쓰지 않고 request 를 직접 호출합니다.
 * getData 는 실패를 { data: undefined } 로 삼켜 호출부가 성공과 실패를
 * 구분할 수 없는데, 이 화면은 조회 실패를 화면에 알려야 하기 때문입니다.
 */
export const getLicenseStatus = async () => {
  return await request.get(endpoints.GET_LICENSE.url);
};

/** 서버아이디를 조회합니다. 표기값과 원본을 함께 돌려줍니다. */
export const getServerId = async () => {
  return await request.get(endpoints.GET_LICENSE_SERVER_ID.url);
};

/**
 * 라이선스 키를 활성화합니다.
 *
 * 실패 사유(위조된 키, 다른 서버용, 만료됨 등)를 화면에 그대로 보여줘야 하므로
 * 예외를 삼키지 않고 그대로 던집니다. 백엔드는 검증 실패를 400 으로 돌려주며
 * 본문의 message 에 사유가 담깁니다.
 */
export const activateLicense = async (key) => {
  return await request.post(endpoints.ACTIVATE_LICENSE.url, { key });
};
